import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
//import OauthService from "@/core/services/codebaseauth.service";
import RoleService from "@/core/services/role.service";
 
// action types
export const VERIFY_AUTH = "verifyAuth";
export const LABORAL = "laboral";
export const LOGIN = "login";
export const LOGIN_EXECUTIVE = "loginExecutive";
export const LOGOUT = "logout";
export const UPDATE_AUTH = "updateAuth";
export const UPDATE_INFO = "updateInfo";
export const OBTIENE_TERCEROS = "getTerceros";
export const AGREGAR_TERCERO = "addTercero";
export const UPDATE_INFO_PASSWORD = "updateInfoPassword";

export const RECOVERY_PASSWORD = "recoveryPassword";
// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_TERCEROS = "setTerceros";
export const SET_LABORAL = "setLaboral";
export const SET_ERROR = "setError";
export const SET_ERROR_PASS = "setErrorPass";
export const SET_ERROR_TERCERO = "setErrorTercero";

const state = {
  errors: [],
  errors_pass: [],
  errors_tercero: [],
  terceros:[],
  user: {},
  image:"",
  laboral:{},
  isAuthenticated: !!JwtService.getToken(),
  //isAuthenticatedSSO:  !!OauthService.getSsoToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  /*isAuthenticatedSSO(state) {
    return state.isAuthenticatedSSO;
  }*/
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post({action:"/gateway/usuario/v1/acceso/autenticar"}, credentials)
        .then(({ data }) => {
          console.log('retorna ' + data);
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, ["Acceso incorrecto. Favor verifique su Rut y/o contraseña"]);
        });
    });
  },
  
  [UPDATE_INFO](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/gateway/usuario/v1/acceso/actualizar`},  user)
        .then(({ data }) => {
          context.commit(SET_ERROR,  data.errors);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR,  response.data.errors);
          reject(response)
        });
    });
  },
  [UPDATE_INFO_PASSWORD](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/gateway/usuario/v1/acceso/cambiarclave`},  user)
        .then(({ data }) => {
          context.commit(SET_ERROR_PASS,  data.errors);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR_PASS,  response.data.errors);
          reject(response)
        });
    });
  },
  [AGREGAR_TERCERO](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/gateway/usuario/v1/acceso/tercero`},  user)
        .then(({ data }) => {
          context.commit(SET_ERROR_TERCERO,  data.errors);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR_TERCERO,  response.data.errors);
          reject(response)
        });
    });
  },
  [OBTIENE_TERCEROS](context) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/usuario/v1/acceso/terceros`})
    .then(({ data }) => {
        context.commit(SET_TERCEROS,  data);  
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [RECOVERY_PASSWORD](context, rut) {
    return new Promise((resolve, reject) => {
    ApiService.get({action:`/gateway/usuario/v1/acceso/${rut}/recuperarClave`})
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get({action:"/gateway/usuario/v1/Me"})
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
        })
        .catch(({ response }) => {
          console.log(response);
           context.commit(SET_ERROR, response.data);
           context.commit(PURGE_AUTH);
         });
     } else {
       context.commit(PURGE_AUTH);
     }
   },

   [LABORAL](context) {
    return new Promise((resolve, reject) => {
    ApiService.get({action:"/gateway/usuario/v1/Me/laboral"})
    .then(({ data }) => {
          resolve(data);
          context.commit(SET_LABORAL, data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
};

const mutations = {
 
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_ERROR_PASS](state, error) {
    state.errors_pass = error;
  },
  [SET_ERROR_TERCERO](state, error) {
    state.errors_tercero = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = [];
    JwtService.saveToken(state.user.token);
    RoleService.saveRole("Cliente");
  },
  [SET_LABORAL](state, user) {
    state.laboral = user;
    state.errors = [];
  },
  [SET_TERCEROS](state, data) {
    state.terceros = data.terceros;
    state.errors = [];
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = [];
    JwtService.destroyToken();
   // OauthService.destroySsoToken();
    RoleService.destroyRole();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
